const ASSINATURA_TIPO = {
  RG: { id: 'RG', descricao: 'Registrador', valor: 128 },
  CN: { id: 'CN', descricao: 'Conferidor', valor: 16 },
  VR: { id: 'VR', descricao: 'Verificador', valor: 4 },
  AP: { id: 'AP', descricao: 'Aprovador', valor: 1 }
};

export default ASSINATURA_TIPO;
